import { render, staticRenderFns } from "./ProdutosSacola.vue?vue&type=template&id=13223429&"
import script from "./ProdutosSacola.vue?vue&type=script&lang=js&"
export * from "./ProdutosSacola.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosSacola.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports